import { Theme } from "@mui/material/styles";

interface OwnerState {
  lastItem: boolean;
}

function timelineItem(theme: Theme, ownerState: OwnerState) {
  const { borders } = theme;
  const { lastItem } = ownerState;

  const { borderWidth, borderColor } = borders;

  return {
    "&:after": {
      content: !lastItem ? "''" : undefined,
      position: "absolute" as const,
      top: "2rem",
      left: "17px",
      height: "100%",
      opacity: 1,
      borderRight: `${borderWidth[2]} solid ${borderColor}`,
    },
  };
}

export default timelineItem;
